import {
	initClient,
	initClientNavigation,
} from "rwsdk/client";

initClient(
	//   {
	//   hydrateRootOptions: {
	//     onCaughtError: (e) => { console.trace('caught error from hyd', e) },
	//     onUncaughtError: (e) => { console.trace('uncaught error from hyd', e) },
	//     onRecoverableError: (e) => { console.trace('recoverable error from hyd', e) },
	//
	//   }
	// }
);
initClientNavigation();
